import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";

function Banner() {
  const stats = [
    { value: "100+", label: "Projects Delivered" },
    { value: "4+", label: "Years Experience" },
    { value: "50+", label: "Happy Clients" },
    { value: "15+", label: "Tech Experts" },
  ];

  return (
    <section className="hero-section" id="home">
      {/* ── Animated mesh background ── */}
      <div className="hero-mesh">
        <div className="mesh-orb mesh-orb-1" />
        <div className="mesh-orb mesh-orb-2" />
        <div className="mesh-orb mesh-orb-3" />
        <div className="hero-grid-lines" />
      </div>

      <Container className="hero-container">
        <Row className="align-items-center gy-5">

          {/* ── LEFT: copy ── */}
          <Col lg={6} className="hero-left" data-aos="fade-right">

            {/* badge */}
            {/* headline */}
            <h1 className="hero-heading">
              Digital<br />
              <span className="hero-heading-gradient">Excellence</span><br />
              for Leading<br />
              <span className="hero-heading-outline">Enterprises</span>
            </h1>

            {/* sub */}
            <p className="hero-sub">
              We've delivered <strong>100+</strong> high-impact web &amp; mobile solutions for
              the world's most ambitious startups and established enterprises.
            </p>

            {/* CTAs */}
            <div className="hero-ctas">
              <Link className="hero-btn-primary" to="/aboutus">
                Explore Our Story
                <i className="fa-solid fa-arrow-right ms-2" />
              </Link>
              <Link className="hero-btn-ghost" to="/portfolio">
                View Portfolio
              </Link>
            </div>

            {/* stats row */}
            <div className="hero-stats">
              {stats.map((s) => (
                <div className="hero-stat" key={s.label}>
                  <span className="hero-stat-value">{s.value}</span>
                  <span className="hero-stat-label">{s.label}</span>
                </div>
              ))}
            </div>
          </Col>

          {/* ── RIGHT: floating card visual ── */}
          <Col lg={6} className="hero-right d-none d-lg-flex" data-aos="fade-left">
            <div className="hero-visual">
              {/* main card */}
              <div className="hero-card hero-card-main">
                <div className="hero-card-icon">
                  <i className="fa-solid fa-rocket" />
                </div>
                <div className="hero-card-text">
                  <span className="hero-card-title">Project Launched</span>
                  <span className="hero-card-sub">E-Commerce Platform</span>
                </div>
                <div className="hero-card-check">
                  <i className="fa-solid fa-circle-check" />
                </div>
              </div>

              {/* stats card */}
              <div className="hero-card hero-card-stat">
                <div className="hero-card-stat-grid">
                  <div>
                    <div className="hero-mini-value">98%</div>
                    <div className="hero-mini-label">Client Satisfaction</div>
                  </div>
                  <div className="hero-mini-divider" />
                  <div>
                    <div className="hero-mini-value">4.9★</div>
                    <div className="hero-mini-label">Average Rating</div>
                  </div>
                </div>
              </div>

              {/* tech badge */}
              <div className="hero-card hero-card-tech">
                <i className="fa-solid fa-code" />
                <span>Full‑Stack &amp; Cloud</span>
              </div>

              {/* decorative ring */}
              <div className="hero-ring hero-ring-1" />
              <div className="hero-ring hero-ring-2" />
            </div>
          </Col>

        </Row>
      </Container>
    </section>
  );
}

export default Banner;
